import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { RefundPolicy } from './pages/RefundPolicy';
import { LanguageProvider } from './contexts/LanguageContext';
// ScrollToTop component to handle scrolling when navigating between routes
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // If there's a hash, let the browser handle the smooth scroll to the element
    // Otherwise, scroll to top when pathname changes
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      // Small delay to ensure the element is rendered before scrolling
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <LanguageProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Layout data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-8" />} data-id="element-7" />
            <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-10" />} data-id="element-9" />
            <Route path="/disclaimer" element={<Disclaimer data-id="element-12" />} data-id="element-11" />
            <Route path="/refund-policy" element={<RefundPolicy data-id="element-14" />} data-id="element-13" />
          </Routes>
        </Layout>
      </Router>
    </LanguageProvider>;
}